import apiClient from './api';

export const perfilService = {
  // Listar todos los perfiles
  getAllPerfiles: async () => {
    const response = await apiClient.get('/perfiles');
    return response.data;
  },

  // Obtener perfil por ID
  getPerfilById: async (id) => {
    const response = await apiClient.get(`/perfiles/${id}`);
    return response.data;
  },

  // Crear nuevo perfil
  createPerfil: async (perfilData) => {
    const response = await apiClient.post('/perfiles', perfilData);
    return response.data;
  },

  // Actualizar perfil
  updatePerfil: async (id, perfilData) => {
    const response = await apiClient.put(`/perfiles/${id}`, perfilData);
    return response.data;
  },

  // Eliminar perfil
  deletePerfil: async (id) => {
    const response = await apiClient.delete(`/perfiles/${id}`);
    return response.data;
  },
};

export default perfilService;
